import { LitElement, html } from 'lit';
import '../icons/warning-icon.js';

class QuoteNotAuthorized extends LitElement {
    static properties = {
        quoteReference: { type: String },
        userEmail: { type: String },
    };

    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.quoteReference = '';
        this.userEmail = '';
    }

    _navigateToLanding() {
        window.location.hash = '#/';
    }

    render() {
        return html`
            <div class="hero min-h-[50vh] bg-base-200 rounded-lg">
                <div class="hero-content text-center">
                    <div class="max-w-lg">
                        <h1 class="text-3xl font-bold mb-4">Quote Access Restricted</h1>
                        <p class="mb-6">
                            The account signed in as
                            <strong>${this.userEmail}</strong> is not recognised as a contact for
                            quote <strong>${this.quoteReference}</strong>.
                        </p>

                        <div class="alert alert-row alert-warning mb-6">
                            <warning-icon class="shrink-0"></warning-icon>
                            <span class="text-sm text-left">
                                This quote was sent to a specific contact. If you believe you should
                                have access, please check you are signed in with the correct email
                                address, or contact your account manager.
                            </span>
                        </div>

                        <div class="flex gap-3 justify-center flex-wrap">
                            <button @click="${this._navigateToLanding}" class="btn btn-primary">
                                Enter Different Reference
                            </button>
                            <a
                                href="mailto:info@reach.nz?subject=Quote%20${encodeURIComponent(
                                    this.quoteReference
                                )}%20-%20Access%20Request"
                                class="btn btn-outline"
                            >
                                Contact Support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-not-authorized', QuoteNotAuthorized);
